import type { AnyExtension } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import Placeholder from '@tiptap/extension-placeholder';
import Link from '@tiptap/extension-link';

interface ExtensionOptions {
  placeholder?: string;
  enableLinks?: boolean;
}

export const createFeedbackExtensions = (placeholderOrOptions?: string | ExtensionOptions): AnyExtension[] => {
  const options: ExtensionOptions = typeof placeholderOrOptions === 'string'
    ? { placeholder: placeholderOrOptions }
    : placeholderOrOptions ?? {};

  const extensions: AnyExtension[] = [
    StarterKit.configure({
      heading: false,
      codeBlock: false,
      code: false,
      blockquote: false,
      horizontalRule: false,
      orderedList: false,
    }),
    Underline,
    TextAlign.configure({ types: ['paragraph'] }),
    Placeholder.configure({
      placeholder: options.placeholder || '',
    }),
  ];

  if (options.enableLinks) {
    extensions.push(
      Link.configure({
        openOnClick: false,
        HTMLAttributes: { target: '_blank', rel: 'noopener noreferrer' },
      })
    );
  }

  return extensions;
};

export const feedbackExtensions = createFeedbackExtensions();
